module.exports = __webpack_public_path__ + "static/media/fi-group.1141fe16.png";